import { GetCurrentLoginInformationsOutput } from '@/shared';
import { abpStore_NS, rootStore } from '@/shared/store';
import { IAbp } from '@/shared/abp/interfaces';

class AbpService {
    set(val: any) {
        rootStore.commit(`${abpStore_NS}/set`, val);
    }

    get abp(): IAbp {
        const storeAbp = rootStore.getters[`${abpStore_NS}/get`];
        if (storeAbp.localization) {
            return storeAbp;
        }
        return (abp as any);
    }

    setLoginInfo(val: GetCurrentLoginInformationsOutput) {
        rootStore.commit(`${abpStore_NS}/setLoginInfo`, val);
    }

    get loginInfo(): GetCurrentLoginInformationsOutput {
        return rootStore.getters[`${abpStore_NS}/getLoginInfo`];
    }
}

const abpService = new AbpService();
export default abpService;
